// extracted by mini-css-extract-plugin
export var link = "_s7-0";